import { IGameIdentity } from 'motw_core/Entity/IGameIdentity';
import * as React from 'react';
import { Style } from 'source/app/presentation/Shared/Styles/CSS';
import { IGameIdentityDTO } from '../../../../../../../../motw_core/DTOs/IGameIdentityDTO';

export function IdentityPower({ identity }: { identity: IGameIdentityDTO }) {
	if (identity.iscombo) {
		return null;
	}

	return (
		<div
			{...Style(`identityPower`, {
				opacity: 0.4,
				margin: `10px`
			})}
		>{`power = ${identity.power}`}</div>
	);
}
